import { ButtonIcon } from '@statsbomb/kitbag-components';
import { useSetAtom } from 'jotai';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { messageDataSyncActionAtom } from '../../../atoms/messages';
import useApi, { API_ENDPOINTS } from '../../../hooks/api';

export function RequestStreamsUpdate({ matchId, requestSeasonUpdate }) {
  const api = useApi();
  const intl = useIntl();

  const setMessageDataSyncAction = useSetAtom(messageDataSyncActionAtom);

  const handleClick = async () => {
    const seasonEndpoint = `/update-competition-season-streams`;
    const singleMatchEndpoint = `/update-streams?force_match_id_mapping_update=True`;
    const response = await api.post(
      `${API_ENDPOINTS.videoService}/data/FOOTBALL/matches/${matchId}${
        requestSeasonUpdate ? seasonEndpoint : singleMatchEndpoint
      }`,
    );
    if (response?.data) {
      setMessageDataSyncAction({
        text: intl.formatMessage({
          defaultMessage: 'Stream resync requested',
          id: '32ce3',
        }),
      });
    } else {
      setMessageDataSyncAction({
        text: intl.formatMessage({
          defaultMessage: 'Request to resync failed',
          id: '371de',
        }),
        type: 'error',
      });
    }
  };

  return (
    <ButtonIcon
      size="small"
      onClick={handleClick}
      icon="Refresh"
      title={intl.formatMessage({
        defaultMessage: 'Re-sync Streams',
        id: '9d111',
      })}
    />
  );
}

RequestStreamsUpdate.propTypes = {
  matchId: PropTypes.string.isRequired,
  requestSeasonUpdate: PropTypes.bool,
};
RequestStreamsUpdate.defaultProps = {
  requestSeasonUpdate: false,
};

export default { RequestStreamsUpdate };
